export enum EnvironmentId{
    Staging = "staging",
    Production = "production",
    Testing = "testing",
    LocalStaging = "local-staging",
    LocalProduction = "local-production",
    LocalTesting = "local-testing",
}